import React from "react";

const SelectedSections = React.createContext({});

export const SelectedSectionsProvider = SelectedSections.Provider;
export default SelectedSections;
